import { render, staticRenderFns } from "./twilio-send-sms-output.vue?vue&type=template&id=1ded8f0d&scoped=true"
import script from "./twilio-send-sms-output.vue?vue&type=script&lang=js"
export * from "./twilio-send-sms-output.vue?vue&type=script&lang=js"
import style0 from "./twilio-send-sms-output.vue?vue&type=style&index=0&id=1ded8f0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded8f0d",
  null
  
)

export default component.exports